import React, { memo } from "react";
import MxTooltipContent, { ContentTooltipProps } from "./MxTooltipContent";
import { Box, Grid, SxProps } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxTooltipItemInfo from "./MxTootipitemInfo";
import { EFontFamilies } from "@/shared/theme/theme";
import MxIcons from "@rf-l1/MxIcons";
import { IconExternalLink } from "@tabler/icons-react";

type OmitContentTooltipProps = Omit<ContentTooltipProps, "children" | "template">;
interface MxTooltipItemInfoProps extends OmitContentTooltipProps {
  errors: { label: string; value: string }[];
  children?: React.ReactNode;
  sx?: SxProps;
  onClickAlert?: (state: any) => void;
}
function MxTooltipErrorsViewer(props: MxTooltipItemInfoProps) {
  if (props.errors.length === 0) return null;
  return (
    <MxTooltipContent
      placement="bottom"
      sx={{
        width: 400,
        height: 400,
        ...props.sx
      }}
      template={
        <Grid container rowSpacing={1}>
          <Grid item xs={12} my={0.5}>
            <MxTypography
              variant="overline"
              color="primary.main"
              fontFamily={EFontFamilies.DISPLAY}
              fontWeight={600}
              textAlign={"center"}
            >
              Debe completar los siguientes campos
            </MxTypography>
          </Grid>
          <Grid container item xs={12}>
            {props.errors?.map(
              (error: { label: string; value: string }, index: number) => (
                <Grid
                  container
                  key={index}
                  alignItems={"flex-start"}
                  onClick={e => {
                    e.stopPropagation();
                    props.onClickAlert?.(error);
                  }}
                >
                  <Grid item xs={9}>
                    <MxTooltipItemInfo
                      key={index}
                      label={error.label}
                      value={error.value ?? ""}
                      type="ERROR"
                    />
                  </Grid>

                  {props.onClickAlert && (
                    <Grid item xs={3} textAlign={"right"}>
                      <MxTypography
                        variant="overline"
                        color="primary.main"
                        sx={{
                          textDecoration: "underline",
                          cursor: "pointer"
                        }}
                      >
                        Ver campo
                      </MxTypography>
                      {/* <MxIcons
                        size={16}
                        color="primary.main"
                        children={<IconExternalLink />}
                      /> */}
                    </Grid>
                  )}
                </Grid>
              )
            )}
          </Grid>
        </Grid>
      }
    >
      {props.children}
    </MxTooltipContent>
  );
}

export default memo(
  MxTooltipErrorsViewer,
  (prev, last) => JSON.stringify(prev.errors) === JSON.stringify(last.errors)
);
